import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../components/other/NoRecord";
import ReactPagination from "../../layout/ReactPagination";
import { fetchCourseList } from "../../redux/action/authAction";
import PaginationDropdown from "../../layout/PaginationDropdown";

const Courses = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setPerPageList] = useState(10);
  const { courseList, isLoading } = useSelector((state) => state?.authReducer);
  const [list, setlist] = useState(courseList);

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  // Get paginated data for the current page
  const paginateOrders = list?.slice(
    currentPage * listPerPages,
    (currentPage + 1) * listPerPages,
  );

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = () => {
    dispatch(fetchCourseList());
  };

  useEffect(() => {
    setlist(courseList);
  }, [courseList]);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <Header />
        <div className="py-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ct_invitation_white_bg">
                  <div className="d-flex align-items-center justify-content-between gap-3 mb-5">
                    <h4 className="text-dark text-center ct_fs_24 ct_fw_600 ">
                      Classes
                    </h4>
                  </div>
                  <div className="table-responsive">
                    <table className="table ct_add_room_table">
                      <thead>
                        <tr>
                          <th>S. No.</th>

                          <th>Teacher Name</th>
                          <th>Class</th>
                          {/* <th className="text-end">Access Google Classroom</th> */}
                          <th className="text-end">Action</th>
                        </tr>
                      </thead>

                      {paginateOrders?.length > 0 && (
                        <tbody>
                          {paginateOrders?.map((item, index) => (
                            <tr>
                              <td>{index + 1}</td>

                              <td>{item?.created_by ?? ""}</td>
                              <td>{item?.course_name ?? ""}</td>
                              <td className="text-end">
                                <i
                                  onClick={() => {
                                    navigate(pageRoutes?.courseAssignments, {
                                      state: {
                                        id: item?.course_id
                                      },
                                    });
                                  }}
                                  class="fa-regular fa-eye text-dark ct_cursor_pointer"
                                ></i>
                                {/* <div className="d-flex align-items-center gap-2 justify-content-end">
                                  <a
                                    href={item?.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="Open in Google Classroom"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      class="bi bi-box-arrow-up-right"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                                      />
                                    </svg>
                                  </a>
                                </div> */}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                    {paginateOrders?.length === 0 && (
                      <NoRecord className="text-center" />
                    )}
                  </div>

                  {list?.length > 10 && (
                    <>
                      <div className="d-flex justify-content-between align-items-center mt-4">
                        <div>
                          <PaginationDropdown
                            onChange={(val) => {
                              setPerPageList(val);
                              setCurrentPage(0);
                            }}
                          />
                        </div>
                        <div>
                          <ReactPagination
                            pageCount={Math.ceil(list?.length / listPerPages)}
                            onPageChange={handlePageClick}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Courses;
